// Centralized content data for the portfolio.
// Add / edit videos and capabilities here.

// Public URL for the current résumé PDF. Update here to swap everywhere.
export const RESUME_URL =
  "https://customer-assets-agu9un31.emergentagent.net/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/clcserdl_Dan_McNamara_Resume.pdf";

// Background / bio content for section 05. Keep each row declarative and tight.
export const background = {
  lede:
    "Dan McNamara is a motion designer and VFX artist based in New York. Senior Motion Graphics & VFX Artist at Complex, leading visual production on Hot Ones, Sneaker Shopping, and the celebrity interview series 24 Hours to Live, and advising the design team on AI image and video generation. BFA in Computer Art, School of Visual Arts.",
  experience: [
    {
      span: "2016 — Present",
      employer: "Complex",
      role: "Senior Motion Graphics & VFX Artist",
      note: "Motion packages across 50+ original series. Lead on 24 Hours to Live — storyboards through final delivery, including AI image/video, VFX, edit, sound, and thumbnails. XR environments, cover art, and senior advisor on AI image and video workflows.",
    },
    {
      span: "2010 — 2016",
      employer: "Ralph Lauren",
      role: "Motion Designer / Director of Internal Video",
      note: "Produced 20+ product-knowledge videos per season — designer interviews, showroom shoots, narration, audio sessions, and worldwide DVD distribution; reviewed cuts directly with Ralph Lauren.",
    },
    {
      span: "2008 — 2009",
      employer: "The Onion",
      role: "Animator / Editor — Onion News Network: Future News",
      note: "VFX and graphics for Future News, widescreen conversions, satirical article graphics, and contributions to the Onion SportsDome pilot.",
    },
    {
      span: "2006 — 2009",
      employer: "Edit1",
      role: "Photoshop Artist · Editor · After Effects Artist",
      note: "Animated storyboards and advertising previsualizations for brands and agencies.",
    },
  ],
  // Independent / original work recognition. Paraphrased from public press.
  recognition: [
    "Four New York Television Festival selections: The Calderons (2006), Redeeming Rainbow (2007), Lost Cities (2009), and The Bear, The Cloud, and God (2010).",
    "Comedy Central Test Pilots finalist — Redeeming Rainbow (2007).",
    "The Bear, The Cloud, and God featured on Comedy Central, G4's Attack of the Show!, and Channel Frederator.",
    "Queens Council on the Arts grant, 2019 — public screening of Wish Weasel at the Museum of the Moving Image.",
    "Edinburgh TV Festival New Voice Awards nominee, 2019 — Wish Weasel; screened at 23 festivals that year.",
  ],
};


export const workSamples = [
  {
    id: 1,
    title: "Federer Intro",
    category: "Motion Graphics",
    videoUrl:
      "https://customer-assets.emergentagent.com/job_dan-reel-focus/artifacts/fzdsf4l4_FEDERER_INTRO_CC_FINAL_3.mp4",
  },
  {
    id: 2,
    title: "Oakley Campaign",
    category: "VFX · Motion",
    videoUrl:
      "https://customer-assets.emergentagent.com/job_dan-reel-focus/artifacts/7npn1mm9_OAKLEY_ZOOM_OUT_REV_4x5_REV_2.mp4",
  },
  {
    id: 3,
    title: "Sneaker Shopping: Bryce James",
    category: "Broadcast Graphics",
    videoUrl:
      "https://customer-assets.emergentagent.com/job_dan-reel-focus/artifacts/lz3l7iwp_SS_BRYCE_JAMES_ANI_preview_1.mp4",
  },
  {
    id: 4,
    title: "Sneaker Shopping: Dion",
    category: "Editorial Motion",
    videoUrl:
      "https://customer-assets.emergentagent.com/job_dan-reel-focus/artifacts/61c7v3yh_SS_DION_BLUE_CC_1.mp4",
  },
  {
    id: 5,
    title: "Sneaker Shopping: Kiyan Anthony",
    category: "Motion Design",
    videoUrl:
      "https://customer-assets.emergentagent.com/job_dan-reel-focus/artifacts/n6db5hkm_SS_KIYAN_ANTHONY_INTRO_V3_FINAL_1.mp4",
  },
  {
    id: 6,
    title: "Sneaker Shopping: Ray Allen",
    category: "VFX · Motion Graphics",
    videoUrl:
      "https://customer-assets.emergentagent.com/job_dan-reel-focus/artifacts/nnoj4rsc_SS_RAY_INTRO_FX_R4_1.mp4",
  },
  {
    id: 7,
    title: "Complex Card Show: Tom Brady",
    category: "Broadcast Graphics",
    videoUrl:
      "https://customer-assets.emergentagent.com/job_dan-reel-focus/artifacts/5ce4uhux_2025_CMPLX_CS_Vertical_2000_Tom_Brady_Bowman_Draft_1.mp4",
  },
  {
    id: 8,
    title: "Bryce Fireball Intro",
    category: "VFX · Editorial",
    videoUrl:
      "https://customer-assets.emergentagent.com/job_dan-reel-focus/artifacts/n1ldysek_BRYCE_FIREBALL_INTRO_R1_2.mp4",
  },
];

// Selected clients — brands Dan has shipped work for.
// Each entry: display name + path to a black-on-transparent PNG in /public/logos.
// Source logos (originals) live in /app/scripts/normalize_logos.py alongside
// the script that normalizes them. Preserves alt text for a11y.
// Selected clients — brands Dan has shipped work for.
// Each entry has EITHER a `logo` (path to a black-on-transparent PNG in
// /public/logos) OR a `wordmark` (typeset text rendered in the strip).
// `wordmarkFont`: "serif" | "sans" (default). Used for brands whose primary
// lockup is a stacked mark we don't want to silhouette.
export const clients = [
  { name: "Grey", logo: "/logos/grey.png" },
  { name: "The Onion", logo: "/logos/the-onion.png" },
  { name: "Ralph Lauren", wordmark: "RALPH LAUREN", wordmarkFont: "serif" },
  { name: "Complex", logo: "/logos/complex.png" },
  { name: "First We Feast", logo: "/logos/first-we-feast.png" },
  { name: "New York Islanders", logo: "/logos/islanders.png" },
  { name: "Edit One", logo: "/logos/edit-one.png" },
];

export const capabilities = [
  {
    id: 1,
    title: "Concept & Design",
    description:
      "Visual concepts, styleframes, mood boards, and design systems for motion projects across all platforms.",
  },
  {
    id: 2,
    title: "Motion Graphics & VFX",
    description:
      "High-end motion design, compositing, and visual effects for social, digital, and broadcast content.",
  },
  {
    id: 3,
    title: "Graphics Packages",
    description:
      "Complete graphics systems for series, shows, and branded content with rapid iteration and delivery.",
  },
  {
    id: 4,
    title: "AI-Assisted Workflows",
    description:
      "AI-driven video and image generation for concepting, previsualization, and production acceleration.",
  },
];

// Case studies that appear as their own cards / routes.
// Order in this array = order on the home page (top → bottom).
export const caseStudies = [
  {
    id: "complex-mnnk-bro",
    slug: "complex-mnnk-bro",
    path: "/complex-mnnk-bro",
    title: "Complex × MNNK Bro.",
    subtitle: "AI Worldbuilding & Motion Assets",
    category: "Case Study · Complex · Editorial · Social",
    image:
      "https://customer-assets.emergentagent.com/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/hkjwyr4w_Magazine%20Cover%20Design%20Concept_Revised%20by%20KK_DMAC_260520KK_4x5.jpg",
    imageAspect: "portrait",
    theme: "dark",
  },
  {
    id: "twenty-four-hours-to-live",
    slug: "24-hours-to-live",
    path: "/24-hours-to-live",
    title: "24 Hours to Live",
    subtitle: "An AI-Driven Social Series",
    category: "Case Study · Complex · TikTok · Instagram",
    accentColor: "#FF2A6D",
    // Vertical key art for the home card preview.
    image:
      "https://customer-assets.emergentagent.com/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/p6736a46_NLE_CHOPPA_THUMB003.png",
    imageAspect: "vertical",
    theme: "dark",
  },
  {
    id: "complex-world",
    slug: "complex-world",
    path: "/complex-world",
    title: "Complex World",
    subtitle: "Current Affairs Documentary Series",
    category: "Case Study · Complex · Documentary · Motion Design",
    image:
      "https://customer-assets-agu9un31.emergentagent.net/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/f43c2rzk_Complex_News_Logo_Treatment%20%280-00-02-15%29.png",
    imageAspect: "vertical",
    theme: "dark",
  },
  {
    id: "first-we-feast",
    slug: "first-we-feast",
    path: "/first-we-feast",
    title: "First We Feast",
    subtitle: "Motion Design & Animation",
    category: "Case Study · Hot Ones · Gochi Gang · The Burger Show · That's Odd, Let's Drink It",
    image:
      "https://customer-assets-agu9un31.emergentagent.net/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/xd7a3hs1_FWF_HOTONES_KEYART.png",
    imageAspect: "vertical",
    theme: "dark",
  },
];

// Media for the Complex × MNNK Bro. × Murakami case study.
export const complexMnnkBroMedia = {
  // Hero in the page header (4:5 portrait magazine cover).
  hero: {
    src: "https://customer-assets.emergentagent.com/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/hkjwyr4w_Magazine%20Cover%20Design%20Concept_Revised%20by%20KK_DMAC_260520KK_4x5.jpg",
    alt: "Complex magazine cover concept — MNNK Bro. × Takashi Murakami",
  },
  // Vinyl edition — the campaign cover adapted into a physical product.
  vinyl: {
    src: "https://customer-assets.emergentagent.com/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/80m40ghe_rev_vinylflowerver.webp",
    alt: "MNNK Bro. vinyl edition — sleeve with flower-shaped record, adapted from the Complex cover artwork",
  },
  // Visual World gallery — supplied campaign imagery.
  gallery: [
    {
      kind: "image",
      src: "https://customer-assets.emergentagent.com/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/jqrbsvry_COMPLEX_MNNKBRO_CAROUSEL%201_%20LAUNCH%20POST-5.jpg",
      label: "Carousel 01 — Launch Post · Flower Portal",
    },
    {
      kind: "image",
      src: "https://customer-assets.emergentagent.com/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/0im0qoe0_COMPLEX_MNNKBRO_Carousel%201_%20QC-3.jpg",
      label: "Carousel 01 — Crystal Diamond Pose",
    },
    {
      kind: "image",
      src: "https://customer-assets.emergentagent.com/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/myrnq7t0_COMPLEX_MNNKBRO_Carousel%203_%20Headline-3.jpg",
      label: "Carousel 03 — Headline · Toy Landscape",
    },
    {
      kind: "image",
      src: "https://customer-assets.emergentagent.com/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/6hsab8ya_COMPLEX_MNNKBRO_Carousel%203_%20QC-1.jpg",
      label: "Carousel 03 — Pull Quote",
    },
    {
      kind: "image",
      src: "https://customer-assets.emergentagent.com/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/4atgnvn5_COMPLEX_MNNKBRO_Carousel%205_%20Headline-1.jpg",
      label: "Carousel 05 — Headline · Chrome Flower",
    },
    {
      kind: "image",
      src: "https://customer-assets.emergentagent.com/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/9prg5jod_COMPLEX_MNNKBRO_Carousel%206_%20QC-1.jpg",
      label: "Carousel 06 — Pull Quote",
    },
    {
      kind: "image",
      src: "https://customer-assets.emergentagent.com/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/9iulon89_COMPLEX_MNNKBRO_Carousel%207_%20Headline-1.jpg",
      label: "Carousel 07 — Headline · Diamond MNNK Bro.",
    },
  ],
  // In-carousel motion piece (already delivered).
  carouselMotion: {
    kind: "video",
    src: "https://customer-assets.emergentagent.com/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/cmzl62w8_COMPLEX_MNNKBRO_Carousel%203_%20QC-3.mp4",
    title: "Carousel 03 — Motion Pull Quote",
    caption:
      "Looping motion piece built for the editorial carousel — extending the still pull-quote slide into atmosphere and movement.",
  },
  // Motion assets — all delivered.
  motion: {
    cover: {
      src: "https://customer-assets.emergentagent.com/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/ubqjgpcd_COMPLEX-COVER_TMKK-JPTHEWAVY_FINAL.mp4",
      title: "Magazine Cover — Motion Edition",
      caption:
        "The Complex cover brought to life. The artists ride through the MNNK Bro. portal as a looping cover motion piece — the marquee animated asset for the campaign.",
    },
    carousel: [
      {
        src: "https://customer-assets.emergentagent.com/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/cmzl62w8_COMPLEX_MNNKBRO_Carousel%203_%20QC-3.mp4",
        title: "Carousel 03 — Motion Pull Quote",
        caption:
          "In-feed loop extending the editorial pull-quote slide into atmosphere.",
      },
      {
        src: "https://customer-assets.emergentagent.com/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/01rvanu1_COMPLEX_MNNKBRO_Carousel%206_%20Headline-3%20%281%29.mp4",
        title: "Carousel 06 — Motion Headline",
        caption:
          "Editorial headline animated for the in-feed carousel slot.",
      },
    ],
  },
};

// Episodes featured on the 24 Hours to Live case study page.
// Each entry maps a guest to their TikTok URL and vertical 9:16 key art.
export const twentyFourHoursToLiveEpisodes = [
  {
    id: "nle-choppa",
    guest: "NLE Choppa",
    summary:
      "A spiritual transition. Meditation with incense and sage in nature, rendered as a vivid AI dreamscape.",
    tiktokUrl: "https://www.tiktok.com/@complex",
    image:
      "https://customer-assets.emergentagent.com/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/p6736a46_NLE_CHOPPA_THUMB003.png",
    featured: true,
  },
  {
    id: "fanum",
    guest: "Fanum",
    summary:
      "An insane itinerary — Bugattis in Dubai, becoming a kung fu master in China, and a final stream from the Burj Khalifa.",
    tiktokUrl: "https://www.tiktok.com/@complex/video/7576852288296340766",
    image:
      "https://customer-assets.emergentagent.com/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/tgvw6ecg_24HOURSTOLIVE_Fanum.jpg",
  },
  {
    id: "cynthia-erivo",
    guest: "Cynthia Erivo",
    summary:
      "A luxury teleportation journey through Paris, Hawaii, Japan, and Turkey.",
    tiktokUrl: "https://www.tiktok.com/@complex/video/7522131823804042527",
    image:
      "https://customer-assets.emergentagent.com/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/rwxxnfry_24Hr_Cynthia_Thumb9.jpg",
  },
  {
    id: "keon-coleman",
    guest: "Keon Coleman",
    summary:
      "A humorous bucket list culminating in shark-infested skydiving.",
    tiktokUrl: "https://www.tiktok.com/@complex/video/7494701859395947806",
    image:
      "https://customer-assets.emergentagent.com/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/sommcjbr_24HOURSTOLIVE_KEON_COLEMAN%20_THUMB004.png",
  },
  {
    id: "bob-odenkirk",
    guest: "Bob Odenkirk",
    summary:
      "A multi-country breakfast tour and singing the seventh-inning stretch at a Cubs game.",
    tiktokUrl: "https://www.tiktok.com/@complex/video/7543738920501087518",
    image:
      "https://customer-assets.emergentagent.com/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/poigmiro_BOB_24_THUMB4.jpg",
  },
  {
    id: "anthony-ramos",
    guest: "Anthony Ramos",
    summary:
      "A fast-paced heritage celebration between New York, Puerto Rico, and Los Angeles.",
    tiktokUrl: "https://www.tiktok.com/@complex/video/7535524008788249887",
    image:
      "https://customer-assets.emergentagent.com/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/s8m98v7n_24HRS_ANTHONYRAMOS_THUMB3.jpg",
  },
];

// Media for the First We Feast case study page.
// `shows` is rendered as stacked sections — one per show — in this order.
// Each item: { type: "video" | "image", src, poster?, label }
// Items with no entries render as a "coming soon" row until assets land.
export const firstWeFeastMedia = {
  shows: [
    {
      id: "hot-ones",
      name: "Hot Ones",
      summary:
        "Motion graphics across the long-running First We Feast flagship.",
      items: [
        {
          type: "video",
          src: "https://customer-assets-agu9un31.emergentagent.net/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/fb6uprhw_FWF_HO_TRUTH_OR_DAB_TITLE_4k_TM_nobug_V1_1.mp4",
          label: "Truth or Dab — Title Animation",
        },
        {
          type: "video",
          src: "https://customer-assets-agu9un31.emergentagent.net/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/5e04f53u_HO_VERSUS_INTRO_ALT.mp4",
          label: "Hot Ones Versus — Intro",
        },
        {
          type: "video",
          src: "https://customer-assets-agu9un31.emergentagent.net/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/fzs4iii0_FWF_HEAT_EATERS_OPENING_SEQUENCE_MZ_V9_FOR_FX_FULL.mp4",
          label: "Heat Eaters — Opening Sequence",
        },
        {
          type: "video",
          src: "https://customer-assets-agu9un31.emergentagent.net/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/wl4hr7c3_HO_ELIZABETH_OLSEN_ANI_PART1.mp4",
          label: "Elizabeth Olsen — 2D Animation",
        },
      ],
    },
    {
      id: "gochi-gang",
      name: "Gochi Gang",
      summary: "Title animation.",
      items: [
        {
          type: "video",
          src: "https://customer-assets-agu9un31.emergentagent.net/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/1al17tqz_GOCHI_GANG_SHOW_OPEN_HERO_SHOTS.mp4",
          label: "Show Open",
        },
      ],
    },
    {
      id: "burger-show",
      name: "The Burger Show",
      summary: "Motion graphics across the series.",
      items: [
        {
          type: "video",
          src: "https://customer-assets-agu9un31.emergentagent.net/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/v7xymjo3_BS_DriveThru_012621_V2.mp4",
          label: "Drive Thru",
        },
        {
          type: "video",
          src: "https://customer-assets-agu9un31.emergentagent.net/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/khy8z4x2_TBS_REGIONALBURGER.mp4",
          label: "Regional Burger",
        },
        {
          type: "video",
          src: "https://customer-assets-agu9un31.emergentagent.net/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/na5p6zgn_TBS_NJ_SLIDERS.mp4",
          label: "NJ Sliders",
        },
        {
          type: "video",
          src: "https://customer-assets-agu9un31.emergentagent.net/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/4vfjm70t_TBS_CROWN_BURGER.mp4",
          label: "Crown Burger",
        },
        {
          type: "video",
          src: "https://customer-assets-agu9un31.emergentagent.net/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/7eltrtxv_TBS_APPLE_PAN.mp4",
          label: "Apple Pan",
        },
        {
          type: "video",
          src: "https://customer-assets-agu9un31.emergentagent.net/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/wtdlj3yj_TBS_PATTY_MELT.mp4",
          label: "Patty Melt",
        },
      ],
    },
    {
      id: "toldi",
      name: "That's Odd, Let's Drink It",
      summary: "Title animation and in-episode motion graphics.",
      items: [
        {
          type: "video",
          src: "https://customer-assets-agu9un31.emergentagent.net/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/tysp9mmv_TOLDI_1.mp4",
          label: "Title Animation",
        },
        {
          type: "video",
          src: "https://customer-assets-agu9un31.emergentagent.net/job_63deb20a-37d0-451f-872c-c4c59d1b6116/artifacts/lzpb3usy_TOLDI_2.mp4",
          label: "Flaming Lips Collaboration — Beer Backstory",
        },
      ],
    },
  ],
};


